// extracted by mini-css-extract-plugin
export default {"datePickerStyles":"datePickerStyles_Sac8m","textalignRight":"textalignRight_p2m3a","textalignLeft":"textalignLeft_KMvx8","textalignCenter":"textalignCenter_IvPRE"};